<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs v-show="filter_cell">
           
            <!-- IP白名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("tabs.white_list") }}</span>
                <div class="main">
                    <p>
                         <el-button @click="daoru()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.impws") }}</el-button>
                        <!-- 导出发件人白名单 -->

                        <el-button @click="daochu4()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.expws") }}</el-button>
                         <!-- 增加IP白名单 -->

                        <el-button @click="show_sender()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.addws") }}</el-button>
                        <el-alert :title="this.load_hind3" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                            <!-- 导入发件人白名单 -->
           <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_import_fromw' }"
            >
              <div class="pop_up_text  pop_up_text_import_fromw">
                <span style="padding:0 14px"></span>{{ $t("table1.impbs") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading">
                            <div class="find1">
                                <!-- ip地址-->

                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_fromw"  class="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save022_from_b">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save24()">{{$t('tan.cancel')}}</el-button>
                        </el-row>

                    </div>
                    <div class="gray" v-show="tanchu"></div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                            </el-table-column>
                           
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_white(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_edit" v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS">
                <span style="padding:0 14px"></span>{{ $t("table1.addws") }}
              </div>
              <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{$t('logs.notify7')}}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="dnoremail" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save21()">保存</el-button>
                            <el-button type="danger" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
          
           
        </el-tabs>
     
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
         
            activeName: 'first',
            pol_list_group_id: '',
            fileList_group_list: [],
            cfg_hint: '', //
            q_action_type: [],
            envfrom_policy: 0,
            // 组过滤规则
            regex_type: 'SUBJECT',
            regex_type_arr: [],
            fileList_group_regex: [],
            fileList_group_ipw: [],
            fileList_group_ipb: [],
            fileList_group_wl: [],
            fileList_group_bl: [],
            tanchu_ipw: false,
            tanchu_ipb: false,
            tanchu_wl: false,
            tanchu_bl: false,
            dnoremail: '',
            header_key: '',
            header_key1: '',
            // 策略组所属部门
            add_depapt: '',
            domain_id: '',
            domain_idd: [],
            // 策略组所属用户
            depart_id: '',
            depart_idd: [],
            include_sub_depart: '',
            fileList_group_email: [],
            fileList_group_deport: [],
            action: 1,
            actionn: [],
            tanchu_group: false,
            group_name: '',
            cur_from: '',
            cur_to: '',
            cur_connect: '',
            ipaddr: '',
            filterregex: '',
            score: '',
            direct: '',
            direct_in: '',
            unit_type: '',
            unit_type1: [],
            unit_name_edit: '',
            group_users: '',

            show_hint: '',
            show_hint1: '',
            show_hint2: '',
            show_hint3: '',
            show_hint4: '',
            show_hint5: '',
            loading: false,
            tanchu_edit: false,
           
            tanchu_sender: false,
            tanchu_sender_all: false,
            tanchu_in_pol_all: false,
            tanchu_rule_all: false,
            tanchu_rule: false,
            fileList_group_pop: [],
            load_hind_pop: '',
            // tanchu_rul_all: true,

            filter_cell: true,
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            fileList1: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],
            fileList5: [],
            fileList6: [],
            fileList7: [],
            radio: [],
            load_hind1: '',
            load_hind2: '',
            load_hind3: '',
            load_hind4: '',
            load_hind5: '',
            load_hind6: '',
            load_hind7: '',
            load_hind8: '',
            group_id: '',
            address_pop: '',
            type_pop: '',
            email_name: '',
             files:[],
        };
    },
    mounted() {
        // this.getFileList()
        // this.getFileList1()
        this.getFileList2()
        this.getFileList3()
        // this.getFileList4()
        // this.getFileList5()
        // this.getFileList7()
        // this.getFileList6()

    },
    methods: {
      
        // From白名单增加
        save022_from_b() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
let email_name = JSON.parse(sessionStorage.getItem("usermsg")).EMAIL_NAME;
            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
this.loading=true;

                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_user_wlsender");
                fd.append("email_name", email_name);
                fd.append("sid", sid);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    // console.log(res);
                        this.loading = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                        // this.getFileList2();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;


                        this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)

                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del3')}`,
                        // });
                    }
                    // this.getFileList2();
                });
            }
        },
     inputFileChange(e) {
           
            this.files = e.target.files[0];
            // console.log(this.files,'fangwei');
        },
          save24() {
            this.tanchu = false;
        },
      // FORM白名单导出
        daochu4() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_user_wlsender";
            // console.log(__mode);
let email_name = JSON.parse(sessionStorage.getItem("usermsg")).EMAIL_NAME;

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?email_name=${email_name}&__mode=${__mode}&sid=${sid}`);
        },
     // ip白名单 导入
        daoru() {
            // console.log('aa')
            this.tanchu = true;
            this.$refs.clearFile.value = '';
      
         document.getElementById("iupfile_fromw").value=""
        //  document.getElementById("iupfile_fromb").value=""
        //  document.getElementById("iupfile_recip").value=""
        //  document.getElementById("iupfile_forge").value=""
         
       
            // this.files = ''
            // this.files_ipb = ''
     

       
        },
         // ip白名单保存
        save21() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
let email_name = JSON.parse(sessionStorage.getItem("usermsg")).EMAIL_NAME;
            
            let str = this.$qs.stringify({
                __mode: "save_email_wlsender",
                sid: sid,
               
                dnoremail:this.dnoremail,
                email_name:email_name
               
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false;

                        this.loading = false;
                        this.getFileList2();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
                
            this.ipaddr = "";
        },
        show_sender(){
            this.tanchu_edit=true
            this.dnoremail=''
        },
 show_sender_b(){
            this.tanchu_bl=true
            this.dnoremail=''

        },
          // hei名单保存
        save_sender_b() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
let email_name = JSON.parse(sessionStorage.getItem("usermsg")).EMAIL_NAME;
            
            let str = this.$qs.stringify({
                __mode: "save_email_blsender",
                sid: sid,
               
                dnoremail:this.dnoremail,
                email_name:email_name
               
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_bl = false;

                        this.loading = false;
                        this.getFileList3();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
                
            this.ipaddr = "";
        },
        dianji(a) {
            console.log(a.index)
            this.address_pop = ''
            if (a.index == 0) {
                this.type_pop = 'from'
                this.load_group_pol_from()

            } else if (a.index == 1) {
                this.type_pop = 'to'
                this.load_group_pol_from()

            } else if (a.index == 2) {
                this.type_pop = 'connect'
                this.load_group_pol_from()

            } else if (a.index == 3 && this.direct_in == 'in') {
                this.getFileList6()
            } else if (a.index == 3 && this.direct_in == 'out') {
                this.getFileList7()

            }

        },
        // 组发信个性化设置
        save_pop_table() {
            this.load_group_pol_from()
        },
        show_key(a) {
            // console.log(a)
            if (a == 'HEADERS') {
                this.header_key1 = 1

            } else {
                this.header_key1 = 0

            }
        },
        domain_id_select(domain) {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let domain_id = domain
            let str = this.$qs.stringify({
                __mode: "load_domain_depart",
                sid: sid,
                domain_id: domain_id,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.depart_idd = res.data.ret.q_depart
                        // depart_id
                        // this.getFileList7()
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        // });
                    }
                });
        },
        //组收信个性化设置
        bianji3(index, scope) {
            console.log(index, scope)
            this.email_name = scope.EMAIL_ID
            // console.log(this.group_name)
            this.tanchu_in_pol_all = true
            this.filter_cell = false
            this.direct_in = 'in'
            this.type_pop = 'from'
            this.load_group_pol_from()
            // this.dianji()
            this.activeName = 'first'

        },
        // 组发信个性化设置
        bianji4(index, scope) {
            console.log(index, scope)
            this.email_name = scope.EMAIL_ID
            // console.log(this.group_name)
            this.tanchu_in_pol_all = true
            this.filter_cell = false
            this.direct_in = 'out'
            this.type_pop = 'from'
            this.load_group_pol_from()
            this.activeName = 'first'

            // this.dianji()

        },
        //组规则
        bianji2(index, scope) {
            console.log(index, scope)
            this.email_name = scope.EMAIL_NAME
            // console.log(this.group_name)
            this.tanchu_rule_all = true
            this.filter_cell = false
            this.load_group_regex()
            this.load_group_ipw()
            this.load_group_ipb()
            this.load_group_wl()
            this.load_group_bl()
            this.getFileList_group_depart()

        },
        //组成员
        bianji1(index, scope) {
            // console.log(index, scope)
            this.group_name = scope.GROUP_NAME
            // console.log(this.group_name)
            this.tanchu_sender_all = true
            this.filter_cell = false
            this.getFileList_group_email()
            this.getFileList_group_depart()

        },
        //  删除
        handleClick_out(index, scope) {

            // console.log(index, scope)

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let email_name = scope.EMAIL_ID
            let address = scope.OBJ
            let policy = scope.POLICY1
            let direct = scope.DIRECT
            let type = scope.TYPE
            let chkaction = scope.ACTION

            let str = this.$qs.stringify({
                __mode: "save_email_policy",
                sid: sid,
                email_id: email_name,
                address: address,
                policy: policy,
                direct: direct,
                type: type,
                chkaction: chkaction,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList7()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                });

        },
        // 加载
        getFileList7() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_email_pol_list",
                        sid: sid,
                        direct: 'out',
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList7 = res.data.ret.datalist;
                        if (this.email_name != '') {
                            this.fileList6 = res.data.ret.datalist;
                        }
                        // 
                        this.load_hind8 = res.data.ret.LOAD_HINT;
                        this.actionn1 = res.data.ret.q_action;

                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_in(index, scope) {

            console.log(index, scope)

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let email_name = scope.EMAIL_ID
            let address = scope.OBJ
            let policy = scope.POLICY1
            let direct = scope.DIRECT
            let type = scope.TYPE
            let chkaction = scope.ACTION

            let str = this.$qs.stringify({
                __mode: "save_email_policy",
                sid: sid,
                email_id: email_name,
                address: address,
                policy: policy,
                direct: direct,
                type: type,
                chkaction: chkaction,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList6()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                });

        },
        // 加载
        getFileList6() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_email_pol_list",
                        sid: sid,
                        direct: 'in',
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList6 = res.data.ret.datalist;
                        this.load_hind7 = res.data.ret.LOAD_HINT;
                        this.actionn = res.data.ret.q_action;
                        // this.action = res.data.ret.ACTION;

                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_black_from(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_blsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_email_pol_id: fk_email_pol_id,

                    });
                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList5()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList5() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_allblsender",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList5 = res.data.ret.datalist;
                        this.load_hind6 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_from(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_wlsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_email_pol_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList4()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList4() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_allwlsender",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList4 = res.data.ret.datalist;
                        this.load_hind5 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_black(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_user_email_blsender",
                        sid: sid,
                        ipaddr: ipaddr,
                        email_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList3()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let email_name = JSON.parse(sessionStorage.getItem("usermsg")).EMAIL_NAME;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_allblsender",
                        sid: sid,
email_name:email_name,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList3 = res.data.ret.datalist;
                        this.load_hind4 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_white(index, scope) {

            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                 
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_user_email_wlsender",
                        sid:sid,
                        email_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList2()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let email_name = JSON.parse(sessionStorage.getItem("usermsg")).EMAIL_NAME;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_allwlsender",
                        sid: sid,
email_name:email_name,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                  if(!res){
           
             this.loading = false;
            
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList2 = res.data.ret.datalist;
                        this.load_hind3 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_regex(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let rule_id = scope.RULE_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_regex",
                        sid: sid,
                        rule_id: rule_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList1()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_email_regex",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList1 = res.data.ret.datalist;
                        this.load_hind2 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        //  删除
        handleClick_group(index, scope) {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let email_name = scope.EMAIL_NAME

            let str = this.$qs.stringify({
                __mode: "del_email_name",
                sid: sid,
                email_name: email_name,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del1')}`,
                        });
                    }
                });

        },
        // 编辑
        save_group() {

            // this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_email_name",
                sid: sid,
                email_name: this.email_name,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_group = false
                        this.getFileList()
                        // 总条数

                    }
                })
                
        },
        // 加载
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: " load_email_name",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList = res.data.ret.datalist;
                        this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 显示
        tan: function () {
            this.tanchu_group = true;
            this.email_name = ''
        },
        cancel_group: function () {
            this.tanchu_group = false;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu_edit = false;
        },
        tanOff_b: function () {
            this.tanchu_bl = false;
        },
        
        off_sender() {
            this.tanchu_sender = false;
        },
        off_rule() {
            this.tanchu_rule = false;
        },
        off_ipw() {
            this.tanchu_ipw = false;
        },
        off_ipb() {
            this.tanchu_ipb = false;
        },
        off_wl() {
            this.tanchu_wl = false;
        },
        off_bl() {
            this.tanchu_bl = false;
        },
        // 返回
        save_envfrom_hide() {
            this.tanchu_in_pol_all = false;
            this.filter_cell = true
        },
        // 返回
        save_sender_hide() {
            this.tanchu_sender_all = false;
            this.filter_cell = true
        },
        // 返回
        save_rule_hide() {
            this.tanchu_rule_all = false;
            this.filter_cell = true
        },
        // 组成员设置显示隐藏
        save_sender_show() {
            this.tanchu_sender = true;

        },
        // 组IP黑名单编辑
        save_wl_show() {
            this.tanchu_wl = true;
            this.dnoremail = ''

        },
        save_bl_show() {
            this.tanchu_bl = true;
            this.dnoremail = ''

        },
        // 组IP黑名单编辑
        save_ipb_show() {
            this.tanchu_ipb = true;
            this.ipaddr = ''

        },
        // 组IP白名单编辑
        save_ipw_show() {
            this.tanchu_ipw = true;
            this.ipaddr = ''
            // this.header_key = ''
            // this.regex_type = 'SUBJECT'
            // this.direct = 0
            // this.show_key()

        },
        // 组规则编辑
        save_rule_show() {
            this.tanchu_rule = true;
            this.filterregex = ''
            this.header_key = ''
            this.regex_type = 'SUBJECT'
            this.direct = 0
            this.show_key()

        },
        // 组规则设置保存
        save_rule() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_email_regex",
                sid: sid,
                email_name: this.email_name,
                type: this.regex_type,
                direct: this.direct,
                score: this.score,
                header_key: this.header_key,
                filterregex: this.filterregex,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_rule = false
                        this.loading = false;
                        this.load_group_regex()
                    }
                })
                

        },
        // 加载
        getFileList_group_email() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_user",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.add_depapt = res.data.ret.ADD_DEPART_ON
                        // console.log(this.add_depapt, 'this.add_depapt')
                        this.fileList_group_email = res.data.ret.datalist;
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 策略组所属部门编辑保存
        save_depart() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_depart",
                sid: sid,
                group_name: this.group_name,
                domain_id: this.domain_id,
                depart_id: this.depart_id,
                include_sub_depart: this.include_sub_depart == true ? 1 : 0
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.tanchu = false
                        // this.tanchu_sender = false
                        this.loading = false;
                        this.getFileList_group_depart()
                    }
                })
                

        },
        // 组成员设置编辑保存
        save_sender() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_bulk_user",
                sid: sid,
                group_name: this.group_name,
                group_users: this.group_users,
                type: 1,
                bulkadd: 1,
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_sender = false
                        this.loading = false;
                        this.getFileList_group_email()
                    }
                })
                

        },
        // 组成员设置 删除
        handleClick_sender(index, scope) {

            // console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let fk_grp_pol_id = scope.GROUP_ID
                    let username = scope.USERNAME
                    let type = scope.TYPE
                    let str = this.$qs.stringify({
                        __mode: "del_group_user",
                        sid: sid,
                        fk_grp_pol_id: fk_grp_pol_id,
                        username: username,
                        type: type,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_group_email()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        // 策略组所属部门加载
        getFileList_group_depart() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_depart",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.add_depapt = res.data.ret.ADD_DEPART_ON
                        this.fileList_group_deport = res.data.ret.datalist;
                        this.domain_idd = res.data.ret.q_domain;
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },

        // 组成员设置 删除
        handleClick_deport(index, scope) {

            // console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let fk_grp_pol_id = scope.GROUP_ID
                    let depart_id = scope.DEPART_ID
                    let type = scope.TYPE
                    let str = this.$qs.stringify({
                        __mode: "del_group_depart",
                        sid: sid,
                        fk_grp_pol_id: fk_grp_pol_id,
                        depart_id: depart_id,
                        type: type,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_group_depart()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        // 组过滤规则加载
        load_group_regex() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_email_regex",
                        sid: sid,
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_regex = res.data.ret.datalist;
                        this.regex_type_arr = res.data.ret.q_regex_type;
                        this.score = res.data.ret.score;

                        this.show_hint1 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 组过滤规则删除
        handleClick_group_regex(index, scope) {

            console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let rule_id = scope.RULE_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_regex",
                        sid: sid,
                        rule_id: rule_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_regex()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        // 组IP白名单加载
        load_group_ipw() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_ipwl",
                        sid: sid,
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_ipw = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint2= res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 组IP白名单删除
        handleClick_group_ipw(index, scope) {

            console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_ipwl",
                        sid: sid,
                        ipaddr: ipaddr,
                        fk_email_pol_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_ipw()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        //  组IP白名单 编辑保存  
        save_ipw() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_email_ipwl",
                sid: sid,
                email_name: this.email_name,
                ipaddr: this.ipaddr,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_ipw = false
                        this.loading = false;
                        this.load_group_ipw()
                    }
                })
                

        },
        // 组IP黑名单加载
        load_group_ipb() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_ipbl",
                        sid: sid,
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_ipb = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint3 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 组IP黑名单删除
        handleClick_group_ipb(index, scope) {

            // console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_ipbl",
                        sid: sid,
                        ipaddr: ipaddr,
                        fk_email_pol_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_ipb()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        //  组IP黑名单 编辑保存  
        save_ipb() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_email_ipbl",
                sid: sid,
                email_name: this.email_name,
                ipaddr: this.ipaddr,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_ipb = false
                        this.loading = false;
                        this.load_group_ipb()
                    }
                })
                

        },
        // 组from白名单加载
        load_group_wl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_allwlsender",
                        sid: sid,
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_wl = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint4 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 组from白名单删除
        handleClick_group_wl(index, scope) {

            // console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_wlsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_email_pol_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_wl()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        //  组from白名单编辑保存  
        save_wl() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_email_wlsender",
                sid: sid,
                email_name: this.email_name,
                dnoremail: this.dnoremail,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_wl = false
                        this.loading = false;
                        this.load_group_wl()
                    }
                })
                

        },
        // 组from白名单加载
        load_group_bl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_email_allblsender",
                        sid: sid,
                        email_name: this.email_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_bl = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint5 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 组from白名单删除
        handleClick_group_bl(index, scope) {

            // console.log(index, scope)
            this.$confirm("确定要删除吗", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_email_pol_id = scope.EMAIL_ID

                    let str = this.$qs.stringify({
                        __mode: "del_email_blsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_email_pol_id: fk_email_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_bl()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });

        },
        //  组from黑名单编辑保存  
        save_bl() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_email_blsender",
                sid: sid,
                email_name: this.email_name,
                dnoremail: this.dnoremail,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_bl = false
                        this.loading = false;
                        this.load_group_bl()
                    }
                })
                

        },
        // 
        // 发件人策略加载
        load_group_pol_from() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_email_pol_lization",
                        sid: sid,
                        email_id: this.email_name,
                        direct: this.direct_in,
                        address: this.address_pop,
                        type: this.type_pop
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.load_hind_pop = res.data.ret.LOAD_HINT
                        this.fileList_group_pop = res.data.ret.datalist;
                        this.q_action_type = res.data.ret.q_action_type
                        this.envfrom_policy = res.data.ret.SHOW_CFG
                        this.show_hint5 = res.data.ret.LOAD_HINT
                        this.cfg_hint = res.data.ret.CFG_HINT

                        this.loading = false;

                    }
                })
                
        },
        // 设置对象当前策略保存
        save_group_list(index, row) {
            console.log(index, row)
            // this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let str = this.$qs.stringify({
                __mode: "save_email_policy",
                sid: sid,
                email_id: this.email_name,
                direct: this.direct_in,
                address: this.address_pop,
                type: this.type_pop,
                chkaction: row.VALUE,
                policy: row.KEY

            });
            console.log(str)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        // this.loading = false;
                        this.load_group_pol_from()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
                
        },
        //
    },
};
</script>

<style lang="less" scoped>
.table_policy {
    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(5) {
        text-align: center;

    }
}

// 1
.main {
    display: flex;

    align-items: center;
    border: 2px solid #D2D7E6;
    // background: #f1f1f1;
    margin: 0px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
    // line-height: 28px;
}

.main_text {
    margin-right: 6px;
    margin-left: 6px;
    color: #0e2c5e;
}

.main .main_input {
    margin-right: 6px;
    width: 20%;
}

.main .el-select {
    margin-right: 6px
}

@import "../css/table.less";
@import "../css/lie_td.less";
@import "../css/pou_up.less";
@import "../css/drag.less";

.pop-up .el-radio {
    margin-right: 4px;
}
// /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2){
//     padding-left: 64px;
// }
.pop-up .pop_up_text_ROUTE_ADDRESS{
  width: 100%;
}
.pop_up_text_ROUTE_ADDRESS {
  background: #eee;
}
</style>
